const loginConstraints = {
  email: {
    email: true,
    presence: true
  },
  password: {
    presence: true,
    length: {
      minimum: 5
    }
  }
}

export default {
  loginConstraints
}



// WEBPACK FOOTER //
// ./src/Validations/AuthValidations.js